import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import CustomersList from './CoursesList'
import { axiosInstance } from '../Config'
import secureLocalStorage from 'react-secure-storage'
import Loader from '../Loader'

const CoursesIndex = () => {

    const [data, setData] = useState([])
    const users = secureLocalStorage.getItem("credentials");
    const [customers, setCustomers] = useState([])
    const [loading, setLoading] = useState(false)
    const [activeTab, setActiveTab] = useState('all')


    useEffect(() => {
        window.scrollTo(0, 0)
        getCustomersInfo()
    }, [])

    function getCustomersInfo() {
        setLoading(true)
        axiosInstance.get(`get-instcourse/${users.id}`,{
            headers : {
                Authorization : `Bearer ${users?.token}`
            }
        })
            .then(res => {
                const data = res?.data?.cources.filter(cource => cource.status !== 1)
                setData(data.reverse())
                setCustomers(data)
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const filterCourses = (ftype) => {
        if (ftype) {
            setActiveTab(ftype)
            setData(customers.filter(item => item.cartype === ftype))
        } else {
            setActiveTab('all')
            setData(customers)
        }
    }


    // ==========================================================================================
    const [page, setPage] = useState(1)

    useEffect(() => window.scrollTo(0, 0), [])

    const navigate = useNavigate()

    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filterByName = (e) => {
        const filteredData = customers.filter((session) =>
            session.title.toLowerCase().includes(e.target.value.toLowerCase())
        )
        setData(filteredData)
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Your Courses" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <div
                                            className="ps-form--search-simple"
                                        >
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                onChange={filterByName}
                                                placeholder="Search Courses.."
                                            />
                                            <button>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => setItemsPerPage(e.target.value)}
                                            style={{ width: '110px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>
                                    </div>
                                    <div className='text-end'>
                                        {/* <button type="button" className="button btn-green  color-white">
                                            <i className='icon-plus me-3 fs-5'></i>
                                            Add Customer</button> */}
                                        <button type="button" onClick={() => navigate(-1)} className="button btn-black text-white ms-3">
                                            <i className='icon-arrow-left me-3 fs-5'></i>
                                            back</button>
                                    </div>

                                </div>

                                <div className='mb-4 text-md-start text-center'>
                                    <button className={`button text-black mt-md-0 mt-4 fw-semibold bg-white rounded-4 ${activeTab === 'all' && 'active_course_tab'} me-md-3 me-2`}
                                        onClick={() => filterCourses()}>
                                        All ({customers.length})
                                    </button>
                                    <button className={`button text-black mt-md-0 mt-4 fw-semibold bg-white rounded-4 ${activeTab === 'Manual' && 'active_course_tab'} me-md-3 me-2`}
                                        onClick={() => filterCourses('Manual')}>
                                        Manual ({customers.filter(course => course.cartype === "Manual").length})
                                    </button>
                                    <button className={`button text-black mt-md-0 mt-4 bg-white fw-semibold rounded-4 me-md-3 me-2 ${activeTab === 'Automatic' && 'active_course_tab'}`}
                                        onClick={() => filterCourses('Automatic')}>
                                        Automatic ({customers.filter(course => course.cartype === "Automatic").length})
                                    </button>
                                </div>

                                <CustomersList data={final_data} />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                    <>
                                                        <div key={pagecount} className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                            {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default CoursesIndex